<template>
  <div class="supplement-types text-dark">
    <div class="supplement-types__header">
      <h2>Tillægstyper</h2>
      <button class="do-bttn do-bttn--submit" @click="isCreateModal = true">Opret tillægstype</button>
    </div>
    <div>
      <div v-if="isLoading">
        <Loader></Loader>
      </div>
      <table class="do-table" v-else>
        <thead>
        <th>Kode</th>
        <th>Titel</th>
        <th class="width-50">Konto</th>
        </thead>
        <tbody>
        <tr v-if="supplementTypes.length === 0">
          <td colspan="3">
            <i>Ingen tillægstyper oprettet fundet</i>
          </td>
        </tr>
        <tr v-for="supplement in supplementTypes" :key="supplement.id">
          <td>{{ supplement.code }}</td>
          <td>{{ supplement.title }}</td>
          <td class="width-50">{{ supplement.account }}
            <div
              class="width-50__icon icon__bg-circle icon__bg-circle--danger"
              @click="setTheEditSupplement(supplement)">
              <span class="icon-bin"></span>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <CreateSupplementstype
      v-if="isCreateModal"
      :isSubmitting="isSubmitting"
      :theEditSupplementType="theEditSupplementType"
      @save="createSupplementType"
      @update="updateSupplementType"
      @close="setIsCreateModal(false)"
    ></CreateSupplementstype>
  </div>
</template>

<script>
import docendo from '../../docendo'
import Loader from '../common/Loader.vue'
import CreateSupplementstype from './CreateSupplementstype.vue'

export default {
  components: {CreateSupplementstype, Loader},
  props: {
    schoolId: {
      type: String,
      default: null,
      required: true
    },
    supplementTypes: {
      type: Array,
      default: () => []
    },
    isLoading: {
      default: false
    }
  },
  data () {
    return {
      isCreateModal: false,
      isSubmitting: false,
      theEditSupplementType: null
    }
  },
  methods: {
    setIsCreateModal (bool) {
      this.isCreateModal = bool
      if (!bool) {
        this.theEditSupplementType = null
      }
    },
    readSupplementTypes () {
      this.$emit('readSupplementTypes')
    },
    createSupplementType (supplementType) {
      this.isSubmitting = true
      docendo.createSalarySupplementType(this.schoolId, supplementType.title, supplementType.code, supplementType.account, success => {
        this.readSupplementTypes()
        this.isSubmitting = false
        this.setIsCreateModal(false)
      }, failure => {
        console.log(failure)
        this.isSubmitting = false
      })
    },
    updateSupplementType (endDate) {
      this.isSubmitting = true
      const supplementType = this.theEditSupplementType
      docendo.updateSalarySupplementType(this.schoolId, supplementType.id, endDate, success => {
        this.readSupplementTypes()
        this.isSubmitting = false
        this.setIsCreateModal(false)
      }, failure => {
        console.log(failure)
        this.isSubmitting = false
      })
    },
    setTheEditSupplement (supplementType) {
      this.theEditSupplementType = supplementType
      this.setIsCreateModal(true)
    }
  },
  mounted () {
    this.readSupplementTypes()
  }
}
</script>

<style scoped>

.supplement-types {
  padding: 1rem;
  max-width: 1440px;
}

.supplement-types__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.do-table tr:nth-child(2n) {
  background-color: #f9fafb;
}

.do-table th:last-child,
.do-table td:last-child {
  width: 50%;
  position: relative;
}

.width-50__icon {
  position: absolute;
  top: 2px;
  right: 0;
  opacity: 0;
}

.do-table tr:hover .width-50__icon {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// SupplementsTypes.vue?37a8288b